module.exports = __webpack_public_path__ + "static/media/dasri_logo.64d08926.png";